import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'
import mask from '@alpinejs/mask'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'

// Store
import "./store/modal"
import "./store/basket"
import "./store/favourite"
import "./store/products"
import "./store/catalog"
import "./store/notification"

// Components
import "./components/login"
import "./components/register"
import './components/form'
import './components/forgotPassword'
import "./components/np"
import "./components/search"

Alpine.plugin(collapse)
Alpine.plugin(mask);
Alpine.plugin(intersect);
Alpine.plugin(persist);
window.Alpine = Alpine;
Alpine.start();
